import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementBalanceEmailTemplate.List.IRequest;
type Response = Api.Core.StatementBalanceEmailTemplate.List.IResponse;
type Headers = Api.Core.StatementBalanceEmailTemplate.List.IHeaders;
const url = '/api/Management/StatementBalanceEmailTemplate';
export default async function statementBalanceEmailTemplateListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
